
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prior-authorization",
      function () {
        return require("private-next-pages/prior-authorization.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prior-authorization"])
      });
    }
  